import React from 'react';
import block from 'bem-cn-lite';
import {HTML} from '@doc-tools/components';
import {CardBase} from '@yandex-data-ui/page-constructor';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import {EventProps as EventParams} from 'units/constructor-local/models';
import EventLabel from 'components/Community/common/EventLabel/EventLabel';
import UnpublishedLabel from 'components/UnpublishedLabel/UnpublishedLabel';
import {getEventStatus, getEventUrl} from 'components/Community/common/utils';

import './Event.scss';

const b = block('event-block');

type EventProps = EventParams & WithTranslationProps;

const Event: React.FC<EventProps> = (props) => {
    const {
        id,
        name,
        image,
        url,
        isPublished,
        border,
        isOnline,
        registrationStatus,
        date,
        stream,
        isCanceled,
        record,
        i18nK,
    } = props;
    const status = getEventStatus({registrationStatus, date, stream, isCanceled, record});
    const eventUrl = getEventUrl(id, url);

    return (
        <CardBase className={b()} border={border} url={eventUrl}>
            <CardBase.Header image={image} className={b('header')}>
                <div className={b('label-container')}>
                    <EventLabel status={status} className={b('label')} />
                    {!isPublished && <UnpublishedLabel type="label" />}
                </div>
            </CardBase.Header>
            <CardBase.Content>
                {<p className={b('type')}>{i18nK(isOnline ? 'webinar' : 'event')}</p>}
                {name && (
                    <h4>
                        <HTML>{name}</HTML>
                    </h4>
                )}
            </CardBase.Content>
        </CardBase>
    );
};

export default withTranslation('events')(Event);
